import {useQuery} from '@tanstack/react-query';
import {VIEWER_QUERY_KEY_MAP} from '../api/viewer/constant';
import {viewerQueryFactory} from '../api/viewer/queryFactory';

// ============================================
// useViewerInfoQuery
// ============================================

export function useViewerInfoQuery(
  ...args: Parameters<typeof viewerQueryFactory.viewerInfo>
) {
  return useQuery(viewerQueryFactory.viewerInfo(...args));
}

useViewerInfoQuery.getKey = (
  ...args: Parameters<typeof VIEWER_QUERY_KEY_MAP.viewerInfo>
) => [...VIEWER_QUERY_KEY_MAP.viewerInfo(...args)];

// ============================================
// useViewerEndQuery
// ============================================

export function useViewerEndQuery(
  ...args: Parameters<typeof viewerQueryFactory.viewerEnd>
) {
  return useQuery(viewerQueryFactory.viewerEnd(...args));
}

useViewerEndQuery.getKey = (
  ...args: Parameters<typeof VIEWER_QUERY_KEY_MAP.viewerEnd>
) => [...VIEWER_QUERY_KEY_MAP.viewerEnd(...args)];
